import React, { FC, useCallback } from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import FormDots from '../common/FormDots';
import { Col, InputNumber, Row } from 'antd';
import { Form } from '@ant-design/compatible';
import { getFixedFloatSum } from '../../utils/InvoiceUtils';

const TaxFormFields: FC<any> = ({
	formData,
	form,
	currency,
	state,
	recalculateTotals,
}): React.ReactElement => {
	const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

	const taxKeys = getFieldValue('taxKeys');

	const handleTaxChange = useCallback(
		(val, k) => {
			const taxCharge = val;
			const taxKeys = getFieldValue(`taxKeys`);
			if (taxCharge) {
				setFieldsValue({ [`tax-${k}-amount`]: taxCharge.toString() });
			} else {
				setFieldsValue({ [`tax-${k}-amount`]: undefined });
			}
			const invoiceTax = taxKeys.reduce((acc, k2) => {
				const price = k2 === k ? taxCharge : parseFloat(getFieldValue(`tax-${k2}-amount`)) || 0;
				return getFixedFloatSum(acc, price);
			}, 0);

			setFieldsValue({ invoiceTax: invoiceTax });
			recalculateTotals();
		},
		[getFieldValue, recalculateTotals, setFieldsValue]
	);

	const taxLineItems = taxKeys.map((k, taxIndex) => {
		const taxType = formData[`tax-${k}-taxType`] || taxKeys[taxIndex];
		return (
			<Row key={k}>
				<Col offset={19} span={2}>
					<Form.Item label={taxIndex === 0 ? 'Type' : ''} required={false}>
						{getFieldDecorator(`tax-${k}-taxType`, {
							initialValue: taxType,
						})}
						<div
							style={
								taxIndex === 0
									? {
											height: 40,
											display: 'flex',
											justifyContent: 'start',
											alignItems: 'center',
									  }
									: {
											height: 40,
											display: 'flex',
											justifyContent: 'start',
											alignItems: 'center',
									  }
							}
						>
							{taxType}
						</div>
					</Form.Item>
				</Col>
				<Col span={3}>
					<Form.Item label={taxIndex === 0 ? 'Amount' : ''} required={true}>
						{getFieldDecorator(`tax-${k}-amount`, {
							initialValue:
								formData[`tax-${k}-amount`] ||
								nullSafeGet(`taxItemInitialValues.tax-${k}-amount`, state),
							validateTrigger: ['onBlur'],
							rules: [
								{
									required: true,
									message: 'Please add tax amount.',
								},
							],
						})(
							<InputNumber
								step={0.01}
								style={{ width: '100%' }}
								addonAfter={currency.id}
								onChange={(e) => handleTaxChange(e, k)}
							/>
						)}
					</Form.Item>
				</Col>
			</Row>
		);
	});

	return (
		<div style={{ marginBottom: 32 }}>
			<div className="buyerInvoiceForm__sectionHead">
				<div className="buyerInvoiceForm__sectionHeadPrimary">Tax</div>
				<FormDots />
				{nullSafeGetOrElse('length', taxKeys, 0) > 0 ? (
					getFieldDecorator(`invoiceTax`, {
						validateTrigger: ['onBlur'],
						initialValue: `${nullSafeGetOrElse(`invoiceTax`, formData, 0)}`,
					})(
						<div className="buyerInvoiceForm__sectionHeadSecondary">
							{currency.format(getFieldValue(`invoiceTax`))}
						</div>
					)
				) : (
					<div className="buyerInvoiceForm__sectionHeadSecondary">
						<Form.Item className="mb-0">
							{getFieldDecorator(`invoiceTax`, {
								validateTrigger: ['onBlur'],
								initialValue: `${nullSafeGetOrElse(`invoiceTax`, formData, 0)}`,
								rules: [
									{
										required: true,
										message: 'Please specify tax if any.',
									},
								],
							})(
								<InputNumber
									step={1}
									onChange={recalculateTotals}
									style={{ width: 240 }}
									addonAfter={currency.id}
								/>
							)}
						</Form.Item>
					</div>
				)}
			</div>
			{taxLineItems}
		</div>
	);
};

export default TaxFormFields;
